import { combineEpics } from "redux-observable";

import internalPeopleEpic from "./internalPeople/internalPeople.epic";
import companyContacts from "./externalPeople/companyContacts.epic";
import peopleProfileEpic from "./Profile/profile.epic";

const peopleEpic = combineEpics(internalPeopleEpic, companyContacts, peopleProfileEpic);

export default peopleEpic;
